import React, {useState, useEffect} from "react";
import WeatherIcon from "../weather-icon/weather-icon";
import axios from "axios";
import "./forecast.css";
import {BASE_URL, KEY } from "../../constants";
import { Row, Grid, Card, Text} from "@nextui-org/react";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);
  
  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);

  const handleResponse = (response) => {
    setForecast(response.data.daily);
    setLoaded(true);
  };

  const getForecastData = () => {
    const latitude = props.coordinates.lat;
    const longitude = props.coordinates.lon;
    const apiUrl = `${BASE_URL}/onecall?lat=${latitude}&lon=${longitude}&appid=${KEY}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  };


  const MockItem = (props) => {
    //*
  const getMaxTemperature = () => {
    const temperature = Math.round(props.data.temp.max);
    return `${temperature}º`;
  };

  const getMinTemperature = () => {
    const temperature = Math.round(props.data.temp.min);
    return `${temperature}º`;
  };

  const getDay = () => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
  ];
  let date = new Date(props.data.dt * 1000);
  let day = date.getDay();

  return days[day];
  }
  //*
  const cardGlassStyles = {
    backdropFilter: "blur(3px) saturate(135%)",
    backgroundColor: "rgba(248, 248, 248, 0)",
    borderRadius: "12px",
    border: "1px solid rgba(209, 213, 219, 0.151)",
    boxShadow: "7px 22px 37px -9px rgba(58, 58, 58, 0.103)",
    ht: "$45",
    textAlign: "center",
  };



    return (
      <Card css={cardGlassStyles}>
          <Text h6 size={15} color="black" css={{ mt: "$xs" }}>
            {getDay()}
          </Text>
        <Card.Body css={{ textAlign: "center" }}>
          <WeatherIcon id={props.data.weather[0].icon} size={68}/>
          <p className="status">{props.data.weather[0].main}</p>
          <Text h6 size={15} color="black" css={{ mt: "$xs" }}>
            {getMinTemperature()} | {getMaxTemperature()}
          </Text>
        </Card.Body>
      </Card>
    );
  };

  if(loaded) {
    return (
    
      <Grid.Container gap={1} fluid>
        {forecast.map((daily, index) => {
            if (index < 6) {
              return (
                <Grid xs={4} md={2} lg={2} key={index}>
                  <MockItem data={daily}/>
                </Grid>
              );
            } else {
              return null;
            }
          })}
      </Grid.Container>
    
  );

  } else {
    getForecastData();

    return null;
  }
}